import React from 'react'
import { Icon } from "@material-ui/core";
import GrafanaLogo from './grafana.svg'

export const GrafanaIcon = () => (
    React.createElement(Icon, null
        , React.createElement('img', { src: GrafanaLogo, alt: "", height: 25, width: 25,})
    )
)